import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getter'
import state from './state'
import mutations from './mutations'

Vue.use(Vuex)

export default new Vuex.Store({
    state,
    getters,
    mutations
})
